import { useState } from "react";
import { compareItems } from "@/mocks/home";

export default function CompareSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="border-t border-background-200/70 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex scroll-mt-24 flex-col gap-3 md:mb-10 md:flex-row md:items-end md:justify-between" id="compare">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest2 text-accent-700">
              <span className="font-heading text-base">04</span>
              <span className="h-px w-6 bg-accent-500" />
            </p>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              同款穿搭 · 生图对比
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              原图即真实状态，生图是同款换搭思路。左边看状态，右边找灵感。
            </p>
          </div>
          <div className="flex items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-600">
            <i className="ri-magic-line text-accent-600" />
            已累计生成
            <span className="font-heading font-bold text-primary-700">3,600+</span>
            组对比
          </div>
        </div>

        <div className="space-y-5">
          {compareItems.map((item, idx) => {
            const open = openIndex === idx;
            return (
              <article
                key={item.id}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <div className="grid grid-cols-1 md:grid-cols-2">
                  {/* 原图 */}
                  <div className="relative">
                    <div className="flex items-center justify-between px-4 py-3">
                      <span className="inline-flex items-center gap-1.5 text-xs font-medium text-secondary-800">
                        <i className="ri-camera-line" /> 路人视角原图
                      </span>
                      <span className="text-[11px] text-foreground-400">{item.source}</span>
                    </div>
                    <img
                      src={item.real}
                      alt={`吃瓜图集同款穿搭原图：${item.title}`}
                      title="吃瓜图集 · 同款穿搭原图"
                      className="h-64 w-full object-cover object-top md:h-80"
                    />
                  </div>

                  {/* 生图 */}
                  <div className="relative border-t border-background-200 md:border-l md:border-t-0">
                    <div className="flex items-center justify-between px-4 py-3">
                      <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-700">
                        <i className="ri-magic-line" /> 同款生图对比
                      </span>
                      <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-900">
                        换搭思路
                      </span>
                    </div>
                    <img
                      src={item.gen}
                      alt={`吃瓜图集同款穿搭生图：${item.title}`}
                      title="吃瓜图集 · 同款穿搭生图"
                      className="h-64 w-full object-cover object-top md:h-80"
                    />
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : idx)}
                  className="flex w-full cursor-pointer items-center justify-between gap-3 border-t border-background-200 px-4 py-4 text-left md:px-5"
                >
                  <span className="flex items-center gap-3">
                    <span className="grid h-8 w-8 shrink-0 place-items-center rounded-md bg-secondary-100 text-secondary-800">
                      <i className={`ri-arrow-left-right-line ${open ? "" : ""}`} />
                    </span>
                    <span>
                      <span className="font-heading text-base font-bold text-foreground-950">
                        {item.title}
                      </span>
                      <span className="mt-0.5 block text-xs text-foreground-500 md:hidden">
                        展开看换搭细节
                      </span>
                    </span>
                  </span>
                  <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-background-100 text-foreground-600">
                    <i className={`${open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-lg`} />
                  </span>
                </button>

                {open && (
                  <div className="border-t border-background-200 bg-background-100/60 px-4 py-4 md:px-5">
                    <p className="text-sm leading-relaxed text-foreground-600">
                      这张「{item.title}」的来源是{item.source.replace("原图来自 · ", "")}。
                      左边为路人视角直出的真实状态，右边为同款单品的一键换搭生图：
                      尝试不同材质、配色与叠穿层次，直观感受同一件衣服在不同语境下的气质差异。
                    </p>
                    <div className="mt-3 flex flex-wrap gap-2">
                      {["材质对比", "配色延展", "叠穿层次"].map((t) => (
                        <span
                          key={t}
                          className="rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-600"
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </article>
            );
          })}
        </div>

        <div className="mt-8 rounded-lg border border-background-200 bg-background-50 p-5 md:flex md:items-center md:justify-between md:p-6">
          <p className="text-sm text-foreground-600">
            想给手边某件单品找搭法？直接贴图或描述，即可一键生成同款换搭对比。
          </p>
          <button
            type="button"
            className="mt-3 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:mt-0 dark:text-foreground-950"
          >
            <i className="ri-upload-2-line" /> 上传一件单品试试
          </button>
        </div>
      </div>
    </section>
  );
}